module.exports = __webpack_public_path__ + "static/media/P27.24fc091d.jpg";